<div class="sgt-representante-modalidade-comercial-multiselect">
    <ngx-bootstrap-multiselect
        [settings]="settings"
        [texts]="texts"
        [options]="options"
        [(ngModel)]="modalidades"
        (ngModelChange)="onChange()"
        [disabled]="disabled">
    </ngx-bootstrap-multiselect>
</div>